import { Component } from '../../types';
import api from '../../utils/api';
import { omit } from 'lodash/fp';

export const updateComponent = (variables: Component) =>
  api.put({
    url: `/component/${variables.id}`,
    variables: omit(['id'], variables),
  });
